import React from 'react';
import Flagship from '../../core/flagship';
import {Dropdown, Segment, Button, Icon, Label, Header} from 'semantic-ui-react';
import UserData from '../user/UserData';
import {throttle, empty} from '../../utils/helpers';

class UserField extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = this.getInitialState();
        this.onSearchChange = this.onSearchChange.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onReset = this.onReset.bind(this);
        this.setInputRef = this.setInputRef.bind(this);
        this.focusUserInput = this.focusUserInput.bind(this);

        this.userInput = null;
        this.preventFocus = this.props.preventFocus;
        this.focusUserInput = this.focusUserInput.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
    }

    getInitialState() {
        return {
            searchResults: [],
            emptySearch: false,
            userData: this.props.userData,
            focused: !this.props.preventFocus
        }
    }

    componentDidMount() {
        if (this.preventFocus !== true) {
            this.focusUserInput();
        }
    }

    focusUserInput() {
        if (this.userInput) {
            this.userInput.focus();
        }
    }

    setInputRef(element) {
        this.userInput = element;
    }

    searchUsers(like) {
        let self = this;

        Flagship.get(
            "dropdown-search/user",
            {
                "search": like
            },
            function(response) {
                if (response.data.success === true) {

                    self.setState({
                        searchResults: response.data.results,
                        emptySearch: (empty(response.data.results) || response.data.results.length === 0)
                    });

                } else {
                    Flagship.error("Could not retrieve dropdown search results for user field. Query: " + like, 0, 0);
                }
            }, function(err) {
                Flagship.error("An error occurred in dropdown search: " + err, 0, 0);
            }
        );
    }

    onChange(e, data) {

        if (typeof this.props.onChange === "function" ) {
            this.props.onChange(e, data);
        }
    }

    onSearchChange(e, data) {

        this.props.onChange(null, {value: false})

        let search = this.searchUsers.bind(this);
        this.timer = throttle( function() {
            search(data);
        }, 400, this.timer);
    }

    onReset() {
        let self = this;
        this.preventFocus = false;
        this.setState({
            userData: null,
            focused:true
        }, function() {
            self.focusUserInput();
            self.onChange(null,{value:''});
        });
    }

    handleFocus() {
        this.setState({
            focused: true
        });
    }

    handleBlur() {
        this.setState({
            focused: false
        });
    }

    render() {

        if(
            this.state.userData !== null &&
            typeof this.state.userData !== "undefined" &&
            typeof this.state.userData.id !== "undefined" &&
            this.state.userData.id !== null) {
            return (
                <div>
                    <Label size="large">
                        {this.props.label}
                        {this.props.required === "1" || this.props.required === true || this.props.required === 1 ?
                            <Icon color="red" size="tiny" className="asterisk" name="asterisk" />
                            : null
                        }
                    </Label>
                <Header as='h5' attached="top">
                    {this.state.userData.first_name} {this.state.userData.last_name}
                </Header>
                <Segment attached>
                    <UserData userData={this.state.userData} />
                    <Button style={{width:"150px"}} secondary onClick={this.onReset} content="Change User" />
                </Segment>
                </div>

            );
        }
        return (
            <div>
                <Label className="single-field-label" size="large">
                    {this.props.label}
                    {this.props.required === "1" || this.props.required === true || this.props.required === 1 ?
                        <Icon color="red" size="tiny" className="asterisk" name="asterisk" />
                        : null
                    }
                </Label>
                <Dropdown
                    className="user-search"
                    fluid
                    search
                    searchInput={{ autoFocus: !this.preventFocus }}
                    placeholder="Search by name..."
                    selection
                    noResultsMessage="No users found by this name."
                    label={this.props.label}
                    onChange={this.onChange.bind(this)}
                    onSearchChange={this.onSearchChange.bind(this)}
                    options={this.state.searchResults}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                />
                {this.state.emptySearch === true ?
                    <div><br/>No matching users found.</div>
                    :
                    this.state.focused === true ? <div><br/><br/></div> : null
                }


            </div>
        );

    }

}

export default UserField;



// WEBPACK FOOTER //
// ./src/components/records/UserField.js